module.exports = __webpack_public_path__ + "static/img/03icon.3950215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/03icon.png
// module id = iD+u
// module chunks = 2